export default __webpack_public_path__ + "images/9b11fb16577adeba1ab85742ffd172a2-gratitude-letter.svg";